import { createMiddleware } from "@tanstack/react-start";

/**
 * SSR-sicherer Ersatz für das generierte `attachSupabaseAuth`.
 *
 * Das generierte Middleware-Modul importiert den Browser-Supabase-Client auf
 * Modulebene. Der liest `localStorage` beim Import – in `src/start.ts` (läuft
 * bei jedem SSR-Request) führt das zu `ReferenceError: localStorage is not
 * defined` und damit zu 500ern auf allen Seiten.
 *
 * Diese Variante lädt den Client erst zur Laufzeit im Browser, per dynamischem
 * Import, und ist damit SSR-sicher. Bitte NICHT durch das generierte
 * `attachSupabaseAuth` ersetzen.
 */
export const attachSupabaseAuthSafe = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (typeof window === "undefined") {
      return next();
    }

    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;

      if (token) {
        return next({ headers: { Authorization: `Bearer ${token}` } });
      }
    } catch {
      // Ohne Session einfach unauthentifiziert weiterlaufen.
    }

    return next();
  },
);
